import _ from 'underscore';
import { CampaignuiBaseColumn } from '@bingads-webui-campaign/campaignui-base-column';
import { toHex, contrastColor } from '@bingads-webui-universal/primitive-utilities';
import template from './labels-column-template.pug';
import headerTemplate from './labels-column-header-template.pug';

export class LabelsColumn extends CampaignuiBaseColumn {
  constructor(options) {
    const title = options.i18n.getString('ColumnName_Labels');
    const isMCCLabelEnabled = options.permissions ?
      options.permissions.IsAccountLabelsEnabled : false;

    super({
      name: 'Labels',
      property: 'Labels',
      title,
      type: 'array',
      helpId: 'pop_BA_CampaignGrids_Labels',
      helpAriaLabel: options.i18n.getString('Click to learn more about {{item}}', { item: title }),
      headerTemplate: isMCCLabelEnabled ?
        (args => headerTemplate({ i18n: options.i18n, ...args })) : undefined,
    });
    this.i18n = options.i18n;
    this.isMCCLabelEnabled = isMCCLabelEnabled;
  }

  pickProperty(item) {
    const { $total, Labels } = item;
    return {
      isAggregateRow: !_.isUndefined($total),
      labels: Labels,
    };
  }

  template({ value }) {
    const { isAggregateRow, labels } = value;
    const maxLabelsToShow = 2;
    const labelsLength = _.isEmpty(labels) ? 0 : labels.length;
    const labelsCountToShow = _.min([labelsLength, maxLabelsToShow]);
    const labelsToUse = [];

    for (let i = 0; i < labelsCountToShow; i += 1) {
      const label = labels[i];
      const title = _.isEmpty(label.Description) ?
        label.Name :
        this.i18n.getString('label_tooltip_format').replace('{0}', label.Name).replace('{1}', label.Description);

      labelsToUse.push(_.extend(
        _.pick(label, 'Id', 'Name', 'Scope'),
        {
          labelColor: toHex(label.ColorCode),
          contractColor: toHex(contrastColor(label.ColorCode)),
          title,
        }
      ));
    }

    return template({
      Labels: labelsToUse,
      ShowViewMoreLink: labelsLength > maxLabelsToShow,
      TotalLength: labelsLength,
      IsAggregateRow: isAggregateRow,
      i18n: this.i18n,
      isMCCLabelEnabled: this.isMCCLabelEnabled,
    });
  }
}
